export const UPDATE = "questions/UPDATE";
export const APPEND = "questions/APPEND";
export const PREPPEND = "questions/PREPPEND";
export const UPDATE_ONE = "questions/UPDATE_ONE";
export const DESTROY = "questions/DESTROY";
export const LOADING = "questions/LOADING";
